import { getOneSpecies } from '../api';

const speciesCache = new Map();
const inflightRequests = new Map();

function normalizeSpeciesPayload(payload) {
  const species = payload?.species || payload?.data || payload || {};
  const scientificName = species.species || species.scientific_name || species.name || '';
  const commonName = species.common_name || species.vernacular_name || '';

  return {
    taxonKey: species.taxonKey || species.taxon_key || species.item_type_id || null,
    scientificName,
    commonName,
    family: species.family || '',
    rank: species.taxonRank || species.taxon_rank || species.rank || '',
  };
}

export async function fetchHotspotSpeciesMeta(taxonKey) {
  if (!taxonKey) return null;

  const cacheKey = String(taxonKey);
  if (speciesCache.has(cacheKey)) {
    return speciesCache.get(cacheKey);
  }

  if (inflightRequests.has(cacheKey)) {
    return inflightRequests.get(cacheKey);
  }

  const request = getOneSpecies(cacheKey)
    .then(({ data }) => {
      const normalized = normalizeSpeciesPayload(data);
      speciesCache.set(cacheKey, normalized);
      return normalized;
    })
    .catch(() => null)
    .finally(() => {
      inflightRequests.delete(cacheKey);
    });

  inflightRequests.set(cacheKey, request);
  return request;
}

export function deriveHotspotNames(hotspot, speciesMeta) {
  const scientificName =
    hotspot?.scientific_name || hotspot?.species || speciesMeta?.scientificName || '';
  const commonName = hotspot?.common_name || speciesMeta?.commonName || '';
  const fallback = hotspot?.taxonKey ? `Taxon ${hotspot.taxonKey}` : 'Mixed community';

  const primaryName = commonName || scientificName || fallback;
  const secondaryName =
    commonName && scientificName && commonName.toLowerCase() !== scientificName.toLowerCase()
      ? scientificName
      : !commonName && scientificName
        ? scientificName
        : '';

  return {
    primaryName,
    secondaryName,
    scientificName: scientificName || 'Scientific name unavailable',
    commonName: commonName || 'Common name unavailable',
  };
}
